import React, {useEffect, useRef, useState} from 'react';
import SpinnerComponent from "../SpinnerComponent/SpinnerComponent";

const LoadingTable = ({loadingObject,children,spinnerStyle}) => {
    const loadingKey = useRef('')
    const loadingType = useRef('')

    const [loadingEquality,setLoadingEquality] = useState(false)

    useEffect(()=>{
        if(Object.keys(loadingObject)[0])
            loadingKey.current = Object.keys(loadingObject)[0]
    },[])

    useEffect(()=>{
        loadingType.current = getEndOfKey(loadingKey.current)
    },[loadingKey])

    useEffect(()=>{
        setLoadingEquality(loadingType.current ==='isLoaded' && Object.values(loadingObject)[0] || loadingType.current === 'isLoading' && !Object.values(loadingObject)[0])
    },[loadingObject])


    function getEndOfKey(key) {
        const currentKey = key.toString().toLowerCase()
        return currentKey.endsWith('ing') ? 'isLoading' : currentKey.endsWith('ed') ? 'isLoaded' : ''
    }

    return (
        <React.Fragment>
            {loadingEquality ? children : <SpinnerComponent style={spinnerStyle}/>}
        </React.Fragment>
    );
};

export default LoadingTable;
